import { Button } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import React from 'react';

import styles from '@lmt/unicorn-shared/app/components/screen-plugs/StartErrorPage.module.scss';

type Props = {
  title: string;
  text: string;
  logoIcon: any;
  logoClassName?: string;
  rainbowIcon: any;
  rainbowClassName?: string;
  button?: { title: string; onClick: () => void };
};

const StartErrorPage: React.FC<Props> = React.memo(function StartErrorPage(
  props: Props,
) {
  const Logo = () => (
    <img className={props.logoClassName} src={props.logoIcon} alt={''} />
  );
  const Rainbow = () => (
    <img className={props.rainbowClassName} src={props.rainbowIcon} alt={''} />
  );
  return (
    <div className={styles.container}>
      <div className={styles.rainbowLeft}>
        <Rainbow />
      </div>
      <div className={styles.info}>
        <div className={styles.message}>
          <div className={styles.title}>{props.title}</div>
          <div className={styles.text}>{props.text}</div>
          {props.button && (
            <Button
              className={styles.button}
              title={props.button.title}
              onClick={props.button.onClick}
            />
          )}
        </div>
        <div className={styles.logo}>
          <Logo />
        </div>
      </div>
      <div className={styles.rainbowRight}>
        <Rainbow />
      </div>
    </div>
  );
});
export default StartErrorPage;
